export const setHeaderTitle = (headerTitle: string) => localStorage.setItem('headerTitle', headerTitle);

export const clearHeaderTitle = () => localStorage.removeItem('headerTitle');

export const getHeaderTitle = () => localStorage.getItem('headerTitle');
